/* global ModuloTS jQuery Drupal drupalSettings */

/* eslint-disable no-loop-func */
/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
/* eslint-disable prefer-template */
/* eslint-disable camelcase */
/* eslint-disable prefer-const */
/* eslint-disable no-console */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable no-unused-vars */
(function ($, Drupal, drupalSettings) {
	// Vars
	const agendaTrans = ModuloTS['Add to my calendar'];
	let calendar = {
		root: document.querySelector('#event-calendar'),
		infos: drupalSettings.event.node_infos,
		event: drupalSettings.event.calendar_dates,
	};

	const arrEvent = []; // récupere les mois et années de l'event  pour chaque date
	for (let year in calendar.event) {
		for (let month in calendar.event[year]) {
			arrEvent.push([month, year]);
			// On trie par mois: du plus petit au plus grand
			arrEvent.sort();
		}
		// On trie par année: a représent index et b représente index+1
		arrEvent.sort((a, b) => {
			return a[1] - b[1];
		});
	}

	let multipleDates;
	if (arrEvent.length > 1) {
		multipleDates = true;
	} else {
		multipleDates = false;
	}
	/**
	 * Permet de retourner l'url pour ajouter un event sur google calendar.
	 *
	 * @param start_date
	 * @param end_date
	 * @param infos
	 * @returns {string}
	 */
	function format_google_link(start_date, end_date, infos) {
		const dates =
			// eslint-disable-next-line no-use-before-define
			format_rfc_3339_date(start_date) +
			'/' +
			format_rfc_3339_date(end_date);

		const google_url =
			// eslint-disable-next-line prefer-template
			'http://www.google.com/calendar/event?action=TEMPLATE&text=' +
			infos.title +
			'&dates=' +
			dates +
			'&sprop=website:' +
			window.location.origin +
			'&location=' +
			infos.location +
			'&details=' +
			window.location.href;

		return encodeURI(google_url);
	}

	/**
	 * Permet de retourner l'url pour ajouter un event sur yahoo calendar.
	 *
	 * @param start_date
	 * @param end_date
	 * @param infos
	 * @returns {string}
	 */
	function format_yahoo_link(start_date, end_date, infos) {
		const yahoo_url =
			// eslint-disable-next-line prefer-template
			'http://calendar.yahoo.com/?v=60&TITLE=' +
			infos.title +
			'&ST=' +
			format_rfc_3339_date(start_date) +
			'&ET=' +
			format_rfc_3339_date(end_date) +
			'&URL=&desc=' +
			window.location.href;

		return encodeURI(yahoo_url);
	}

	/**
	 * Bien fournir la date au format YYYY-mm-ddThh:ii:ssZ exemple : 2022-07-20T16:00:00Z au timestamp UTC
	 *
	 * @param date
	 */
	function format_rfc_3339_date(date) {
		if (typeof date === 'string') {
			date = date.replace(/-/g, '');
			date = date.replace(/:/g, '');

			return date;
		}
	}

	/**
	 * Permet de récupérer le lien pour download l'ics
	 * @param node_id
	 * @param date_index
	 * @returns {string}
	 */
	function get_ics_link(node_id, date_index) {
		return '/node/' + node_id + '/' + date_index + '/ics';
	}

	// Global translates only
	const previousBtnTrans =
		ModuloTS["Go back to the previous month's results"];
	const nextBtnTrans = ModuloTS['Access the results of the following month'];

	// Le ''doublon" de variables est nécessaire pour l'a11y et d'éviter de créé une foncton pour split le text (More Opti)
	// Pré-cablâge -> L'a11y sur les jours n'est pas nécessaire à l'instanté - P-e sur une v2
	const daysTrans = {
		sunday: ModuloTS.Sun,
		sundaySr: ModuloTS.Sunday,
		monday: ModuloTS.Mon,
		mondaySr: ModuloTS.Monday,
		tuesday: ModuloTS.Tue,
		tuesdaySr: ModuloTS.Tuesday,
		wednesday: ModuloTS.Wed,
		wednesdaySr: ModuloTS.Wednesday,
		thursday: ModuloTS.Thu,
		thursdaySr: ModuloTS.Thursday,
		friday: ModuloTS.Fri,
		fridaySr: ModuloTS.Friday,
		saturday: ModuloTS.Sat,
		saturdaySr: ModuloTS.Saturday,
	};
	// --

	// init & fetch le mois en cours : method = months[date.getMonths()]
	const months = [
		ModuloTS.January,
		ModuloTS.February,
		ModuloTS.March,
		ModuloTS.April,
		ModuloTS.May,
		ModuloTS.June,
		ModuloTS.July,
		ModuloTS.August,
		ModuloTS.September,
		ModuloTS.October,
		ModuloTS.November,
		ModuloTS.December,
	];

	// Squelette du calendrier
	const buildCalendar = () => {
		// Si plusieurs dates sur l'event, on créé les btn de navigation
		let btnNext;
		let btnPrev;
		if (multipleDates) {
			btnPrev = `<button type="button" role="button" disabled data-nav="prev"  class="btn prev"><span class="sr-only">${previousBtnTrans}</span><i data-icon="chevron"></i></button>`;
			btnNext = `<button type="button" role="button" data-nav="next"  class="btn next"><span class="sr-only">${nextBtnTrans}</span><i data-icon="chevron"></i></button>`;
		} else {
			btnNext = '';
			btnPrev = '';
		}
		const contentCalendar = `<div class="event-calendar__container">
      <div class="month">
      ${btnPrev}
        <div class="date">
          <p></p>
        </div>
        ${btnNext}
      </div>
      <div class="weekdays">
        <div><abbr title="${daysTrans.mondaySr}">${daysTrans.monday}</abbr></div>
        <div><abbr title="${daysTrans.tuesdaySr}">${daysTrans.tuesday}</abbr></div>
        <div><abbr title="${daysTrans.wednesdaySr}">${daysTrans.wednesday}</abbr></div>
        <div><abbr title="${daysTrans.thursdaySr}">${daysTrans.thursday}</abbr></div>
        <div><abbr title="${daysTrans.fridaySr}">${daysTrans.friday}</abbr></div>
        <div><abbr title="${daysTrans.saturdaySr}">${daysTrans.saturday}</abbr></div>
        <div><abbr title="${daysTrans.sundaySr}">${daysTrans.sunday}</abbr></div>
      </div>
      <div class="days"></div>
      <div class="event-calendar__infos"></div>
    </div>`;

		calendar.root.insertAdjacentHTML('beforeend', contentCalendar);
	};

	// Création du Calendrier, date & comportement
	const date = new Date();
	let calendarInit = false; // permet de faire un setMonth&setFullYear une seule fois à la première initialisation du calendar
	const renderCalendar = () => {
		date.setDate(1);
		const monthDays = document.querySelector('.days');
		const eventYear = parseInt(Object.keys(calendar.event));

		let eventFirstMonth = parseInt(arrEvent[0][0], 10);

		let parseEventFirstMonth;
		if (calendarInit === false) {
			if (eventFirstMonth < 10) {
				eventFirstMonth = '0' + eventFirstMonth;
			}
			parseEventFirstMonth = eventFirstMonth - 1;
			// a l'init on set le mois et l'année de l'event pour arriver directement sur le mois de l'event
			date.setMonth(parseEventFirstMonth);
			date.setFullYear(eventYear);
		}
		if (date.getMonth() === 13) {
			// si on arrive à 13 on reset le mois a  01
			date.setMonth(1);
		}
		const lastDay = new Date(
			date.getFullYear(),
			date.getMonth() + 1,
			0
		).getDate();

		const prevLastDay = new Date(
			date.getFullYear(),
			date.getMonth(),
			0
		).getDate();

		const firstDayIndex = (date.getDay() + 6) % 7;

		const lastDayIndex =
			(new Date(date.getFullYear(), date.getMonth() + 1, 0).getDay() +
				6) %
			7;

		const nextDays = 7 - lastDayIndex - 1;
		calendar.root.querySelector('.date p').innerHTML =
			months[date.getMonth()] + '<span></span>';
		calendar.root.querySelector('.date span').innerHTML =
			date.getUTCFullYear();
		let days = '';

		for (let x = firstDayIndex; x > 0; x--) {
			days += `<div class="date prev-date" data-js-prev-day= "${
				prevLastDay - x + 1
			}">${prevLastDay - x + 1}</div>`;
		}

		for (let i = 1; i <= lastDay; i++) {
			let dataDay = i;

			if (i < 10) {
				dataDay = '0' + i;
			}
			if (
				i === new Date().getDate() &&
				date.getMonth() === new Date().getMonth() &&
				date.getFullYear() === eventYear
			) {
				days += `<button class="date today" data-js-day = ${dataDay} disabled tabindex="-1">${i}</button>`;
			} else {
				days += `<button class="date" data-js-day = ${dataDay} disabled tabindex="-1"><span>${i}</span></button>`;
			}
		}

		if (nextDays >= 1) {
			for (let j = 1; j <= nextDays; j++) {
				days += `<div class="date next-date" data-js-next-day="${j}">${j}</div>`;
				monthDays.innerHTML = days;
			}
		} else {
			for (let k = 0; k <= nextDays; k++) {
				days += `<div class="down"></div>`;
				monthDays.innerHTML = days;
			}
		}
	};

	// convertie H:m:s en H:m
	const time = (timer) => {
		const timeSplit = timer.split(':');

		return `${timeSplit[0]}:${timeSplit[1]}`;
	};

	// Mise en place des events
	const eventCalendar = () => {
		// Récupère l'ensemble des datas de l'année en cours

		let yearEvent;
		let monthEvent;
		const hasDate = calendar.event[date.getUTCFullYear()] || null;
		let eventDate = parseInt(Object.keys(calendar.event));
		if (hasDate) {
			yearEvent = calendar.event[date.getUTCFullYear()];
			let newMonth = date.getMonth() + 1;

			if (date.getMonth() + 1 < 10) {
				newMonth = '0' + String(newMonth);
			} else {
				newMonth = String(newMonth);
			}

			monthEvent = yearEvent[newMonth];
		} else {
			yearEvent = calendar.event[eventDate];
			monthEvent = '';
		}
		// drupalSettings.event.calendar_dates[date.getUTCFullYear()];
		// Récupère les mois sur l'année en cours
		// "Regex" permettant d'interprêter le format date renvoyer par le Json

		// Mise en place des informations d'évènements
		const callEvent = document.querySelectorAll('[data-js-day]');
		const shEvent = document.querySelector('.event-calendar__infos');

		// Récupère les jours sur le mois en cours & l'année en cours
		for (const daysEvents in monthEvent) {
			// a11y sur les daysEvents au format ( ex : 05 Octobre 2020 )
			const eventTrans = ModuloTS['See all the events of'];
			const eventMonthTrans = `${
				months[date.getMonth()]
			} ${date.getUTCFullYear()}`;
			// --

			const attrEvent = document.querySelector(
				`[data-js-day="${daysEvents}"]`
			);
			attrEvent.classList.add('event');
			attrEvent.setAttribute(
				'aria-label',
				eventTrans + ` ${daysEvents} ` + eventMonthTrans
			);
			attrEvent.disabled = false;
			attrEvent.setAttribute('aria-expanded', 'false');
			attrEvent.setAttribute('tabindex', 0);
			attrEvent.setAttribute('role', 'button');
			attrEvent.insertAdjacentHTML(
				'afterbegin',
				`<span class="sr-only">${eventTrans}</span>`
			);
			attrEvent.insertAdjacentHTML(
				'beforeend',
				`<span class="sr-only">${eventMonthTrans}</span>`
			);
		}

		callEvent.forEach((call) => {
			call.addEventListener('click', () => {
				let currentMonth = date.getMonth() + 1;
				const currentYear = String(date.getFullYear());
				const eventYear = Object.keys(calendar.event)[0];
				const eventMonth = Object.keys(calendar.event[eventYear])[0];
				if (date.getMonth() + 1 < 10) {
					currentMonth = '0' + String(currentMonth);
				} else {
					currentMonth = String(currentMonth);
				}
				// Si le jour cliqué possède un event on lance les actions
				if (call.classList.contains('event')) {
					callEvent.forEach((allCall) => {
						allCall.setAttribute('aria-expanded', false);
						allCall.classList.remove(
							'event-active',
							'event-active--first',
							'event-active--last'
						);
					});

					call.setAttribute('aria-expanded', true);

					const day = call.getAttribute('data-js-day');
					const dayInfos = infoDay(monthEvent, day);
					if (call.classList.contains('event')) {
						shEvent.innerHTML = dayInfos;
						const horaires = JSON.parse(
							JSON.stringify(monthEvent[day])
						);
						let dayStart = horaires[0].start_date.slice(8, 10);
						let dayEnd = horaires[0].end_date.slice(8, 10);
						if (dayEnd >= dayStart) {
							for (let i = dayStart; i <= dayEnd; i++) {
								callEvent.forEach((allCall) => {
									allCall.classList.remove('active');
								});
								if (i === dayStart) {
									if (dayStart !== dayEnd) {
										callEvent[i - 1].classList.add(
											'event-active--first'
										);
									} else {
										callEvent[i - 1].classList.add(
											'event-active--one'
										);
									}
								}
								if (i === dayEnd - 1) {
									callEvent[i].classList.add(
										'event-active--last'
									);
								}
								if (dayStart !== dayEnd) {
									callEvent[i - 1].classList.add(
										'event-active'
									);
									call.classList.add('event-active');
								}
							}
						} else {
							call.setAttribute('aria-expanded', true);
							callEvent.forEach((allCall) => {
								allCall.classList.remove('event-active');
							});
							call.classList.add('active');
						}
					} else {
						shEvent.innerHTML = '';
					}

					const allHour = document.querySelectorAll('.hour-event');

					allHour[0].focus();

					allHour.forEach((el) => {
						el.addEventListener('click', () => {
							const allDis = () => {
								allHour.forEach((hour) => {
									if (hour.classList.contains('active')) {
										hour.classList.remove('active');
										document
											.querySelector(
												'.event-calendar__content .add-event'
											)
											.classList.remove(
												'active',
												'select-event'
											);
										document.querySelector(
											'.event-calendar__content .add-event .btn'
										).disabled = true;
									}
								});
							};

							if (el.classList.contains('active')) {
								allDis();
							} else {
								allDis();
								el.classList.add('active');
								document
									.querySelector(
										'.event-calendar__content .add-event'
									)
									.classList.add('active');
								document
									.querySelector(
										'.event-calendar__content .add-event .btn'
									)
									.removeAttribute('disabled');
								addMyCalendar();
							}

							document
								.querySelector('.add-my-calendar')
								.setAttribute(
									'title',
									`${agendaTrans} ${el.getAttribute(
										'aria-label'
									)}`
								);
							document
								.querySelector('.add-my-calendar')
								.setAttribute('aria-describedby', `${el.id}`);
							document.querySelector('.add-my-calendar').focus();
						});
					});
				}
			});
		});
	};

	// Horaire du jour sélectionner
	const infoDay = (month, day) => {
		if (month[day]) {
			const horaires = JSON.parse(JSON.stringify(month[day]));
			let eventStart = horaires[0].start_date;
			let eventEnd = horaires[0].end_date;
			let eventStartDay = eventStart.slice(8, 10);
			let showEvent;
			const hoursTrans = ModuloTS['Hours at'];
			if (eventStart === eventEnd) {
				showEvent = `<div class="event-calendar__content">
                            <div class="hours-text">${hoursTrans}
                            <span>${day} ${months[date.getMonth()]}</span>
                              </div>
                            <div class="hours-event">`;
			} else {
				let nbDays = eventEnd.slice(8, 10) - eventStart.slice(8, 10);
				let lastDayEvent = nbDays + parseInt(eventStartDay);
				const hoursTransFrom = ModuloTS.From;
				const hoursTransTo = ModuloTS.to;
				showEvent = `<div class="event-calendar__content">
                            <div class="hours-text hours-text--multiple"> ${hoursTransFrom}
                              <span>${eventStartDay} ${
					months[date.getMonth()]
				} </span>
                              ${hoursTransTo}
                              <span>${lastDayEvent} ${
					months[date.getMonth()]
				}</span>
                            </div>
                            <div class="hours-event">`;
			}

			// Permet de récupèrer les datas du jour
			horaires.forEach((horaire, index) => {
				let start = time(horaire.start);
				let end = time(horaire.end);

				const hoursDayTrans =
					ModuloTS.From + ' ' + start + ' ' + ModuloTS.to + ' ' + end;

				showEvent += `<button class="hour-event" id="hour-${index}" tabindex="0" role="button" type="button"
      aria-label="${hoursTrans} ${day} ${
					months[date.getMonth()]
				} ${date.getUTCFullYear()} : ${hoursDayTrans}" data-event="${
					horaire.start_utc
				}$$${horaire.end_utc}">
      <span class="sr-only">${hoursTrans} ${day} ${
					months[date.getMonth()]
				} ${date.getUTCFullYear()}</span>
                      ${start} - ${end}
                    </button>`;
			});

			showEvent += `</div>
                    <div class="add-event">
                      <button class="btn add-my-calendar" tabindex="0" role="button" type="button" aria-expanded="false" disabled><i data-icon="cross"></i>${agendaTrans}</button>
                      <div class="event-calendar__links"></div>
                    </div>
				  </div>`;

			return showEvent;
		}
	};

	const listCalendar = (c, o, g, y) => {
		return `<a href="${c}" target="_blank" aria-label="iCalendar" class="event-calendar__link calendar">iCalendar</a>
                <a href="${o}" target="_blank" aria-label="Outlook" class="event-calendar__link outlook">Outlook</a>
                <a href="${g}" target="_blank" aria-label="Google Calendar" class="event-calendar__link google">Google Calendar</a>
                <a href="${y}" target="_blank" aria-label="Yahoo Calendar"  class="event-calendar__link yahoo">Yahoo Calendar</a>`;
	};

	const listenAddCalendar = () => {
		document.querySelectorAll('.event-calendar__link').forEach((link) => {
			link.addEventListener('click', () => {
				document.querySelector('.event-calendar__content').remove();
			});
		});
	};

	const addMyCalendar = () => {
		document
			.querySelector('.add-event .btn')
			.addEventListener('click', () => {
				document
					.querySelector('.add-event .btn')
					.setAttribute('aria-expanded', 'true');
				const timeSelect = document
					.querySelector('.hour-event.active')
					.getAttribute('data-event');

				const time = timeSelect.split('$$');
				const time_start = time[0];
				const time_end = time[1];
				// liens vers les calendar
				let c;
				const o = (c = get_ics_link(calendar.infos.id, 0));
				const g = format_google_link(
					time_start,
					time_end,
					calendar.infos
				);
				const y = format_yahoo_link(
					time_start,
					time_end,
					calendar.infos
				);

				if (
					document
						.querySelector('.add-event')
						.classList.contains('active')
				) {
					document
						.querySelector('.add-event')
						.classList.add('select-event');
					document.querySelector('.add-event .btn').disabled = false;
				}

				document.querySelector('.event-calendar__links').innerHTML =
					listCalendar(c, o, g, y);

				listenAddCalendar();
			});
	};

	// Events dynamique
	const navCalendar = () => {
		if (arrEvent.length > 1) {
			const buttonPrev = calendar.root.querySelector(
				'.btn[data-nav="prev"]'
			);
			const buttonNext = calendar.root.querySelector(
				'.btn[data-nav="next"]'
			);
			let currentNav = 1;

			// SI plusieurs dates sur l'event on active la navigation
			setTimeout(function () {
				let current = 0;
				calendar.root.querySelectorAll('.btn').forEach((button) => {
					const dataNav = button.getAttribute('data-nav');
					button.addEventListener('click', () => {
						if (dataNav === 'prev') {
							if (current > 0) {
								current--;
								buttonNext.disabled = false;
							} else {
								button.disabled = true;
							}
						} else if (dataNav === 'next') {
							if (current < arrEvent.length - 1) {
								current++;
								buttonPrev.disabled = false;
							} else {
								button.disabled = true;
							}
						}
						const currentMonth = arrEvent[current][0];
						const currentYear = arrEvent[current][1];

						date.setMonth(currentMonth - 1);
						date.setFullYear(currentYear);

						calendarInit = true; // on passe la variable à true pour ne plus set le month et l'année a chaque clique en fonction des variables eventYear et eventFirstMonth  dans renderCalendar()
						renderCalendar();
						eventCalendar();
					});
				});
			}, 1000);
		}
	};

	// GO 🚀
	const init = () => {
		if (document.body.contains(calendar.root)) {
			buildCalendar();
			renderCalendar();
			navCalendar();

			eventCalendar();
		}
	};

	init();
})(jQuery, Drupal, drupalSettings);
